<div class="performance_indicators_notification" [ngClass]="classes">
	<img
		class="performance_indicators_notification__icon"
		src="/assets/images/icons/icon-chart.svg"
		alt="image-icon" />
    {{ "performance_indicators_notification" | translate: [timeframeValue] }}
</div>